// Thai (คุณ register, as the Just One Interview pages) of the two candidate
// pages. Same sections and the same facts as the English master in
// lib/native/candidateEn.js. Change the English source first.
// Dates use the Gregorian year (22 ตุลาคม 2026); the "(ภาษาอังกฤษ)" marker follows links to English pages.
const GOOGLE_BLOG_URL = "https://blog.google/company-news/outreach-and-initiatives/grow-with-google/interview-warmup/";

export const meta = {
  code: "th",
  hreflang: "th",
  nativeName: "ไทย",
  banner: "หน้านี้มีเป็นภาษาไทยด้วย",
  switcherLabel: "ภาษา",
  faqTitle: "คำถามที่พบบ่อย",
  footerPrivacy: "นโยบายความเป็นส่วนตัว (ภาษาอังกฤษ)",
  footerContact: "ติดต่อเรา",
};

export const pages = {
  "interview-warmup": {
    title: "Google Interview Warmup ปิดแล้ว ฝึกสัมภาษณ์งานกับ AI ฟรี",
    description:
      "Google ปิด Interview Warmup ในเดือนเมษายน 2026 ลองฝึกพูดตอบด้วยเสียงกับ AI ที่ Just One Interview แทน เริ่มฟรี ได้รายงานพร้อมคะแนนเมื่อฝึกจบ",
    kicker: "วอร์มอัพก่อนสัมภาษณ์",
    h1: "Google Interview Warmup ปิดไปแล้ว\nวอร์มอัพนี้พูดโต้ตอบกับคุณได้",
    lead:
      "วอร์มอัพสัมภาษณ์งานฟรีบน Just One Interview แอปฝึกสัมภาษณ์ของเรา คุณจะได้คุยด้วยเสียงกับผู้สัมภาษณ์ AI คำถามมาจากตำแหน่งและทักษะที่คุณเลือก และเมื่อจบจะได้รายงานพร้อมคะแนน การเปิดกล้องหรือไม่เป็นสิทธิ์ของคุณ ระบบจะบันทึกวิดีโอรอบฝึกก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมแล้วเท่านั้น",
    note:
      "Google ปิด Interview Warmup ในเดือนเมษายน 2026 และที่อยู่เดิมก็เปิดเครื่องมือนี้ไม่ได้แล้ว [เกิดอะไรขึ้น และควรใช้อะไรแทน](/blog/google-interview-warmup-alternatives) (ภาษาอังกฤษ)",
    cta: "เริ่มฟรี →",
    blocks: [
      {
        type: "answer",
        title: "Google Interview Warmup ยังใช้ได้อยู่ไหม",
        paragraphs: [
          "ไม่ได้แล้ว Google ปิด Interview Warmup ในเดือนเมษายน 2026 และที่อยู่เดิมก็เปิดเครื่องมือนี้ไม่ได้อีก เมื่อเราเปิด grow.google/interview-warmup เมื่อวันที่ 22 ตุลาคม 2026 ระบบพาเราไปที่หน้าแรกของ Grow with Google ของภูมิภาคเราแทน หน้านั้นแสดงหลักสูตรและใบรับรองด้านอาชีพ แต่ไม่มี Interview Warmup สิ่งที่คุณเห็นอาจต่างกันไปตามประเทศ",
          "สำหรับการฝึกพูดแบบฟรี Just One Interview เริ่มใช้ได้ฟรีและไม่ขอบัตร [ดูว่าเทียบกับตัวเลือกฟรีอื่นๆ เป็นอย่างไร](#free-tools) หรือ [ตรวจสอบแหล่งข้อมูลเรื่องการปิดบริการ](#status)",
        ],
      },
      {
        type: "text",
        title: "Google Interview Warmup คืออะไร",
        paragraphs: [
          "Google Interview Warmup เป็นเครื่องมือของ Grow with Google สำหรับฝึกตอบคำถามสัมภาษณ์ Google ประกาศเปิดตัวเมื่อวันที่ 2 มิถุนายน 2022 คุณตอบคำถามที่ผู้เชี่ยวชาญในแต่ละอุตสาหกรรมเลือกไว้ และเครื่องมือจะถอดเสียงคำตอบของคุณขณะที่พูด จากนั้นแสดงข้อมูลเชิงลึก เช่น คำศัพท์เกี่ยวกับงานที่คุณใช้ คำที่คุณพูดบ่อยที่สุด และประเด็นหลักในแต่ละคำตอบ เครื่องมือนี้ไม่ให้คะแนน และเป้าหมายคือช่วยให้คุณมั่นใจขึ้นก่อนสัมภาษณ์จริง",
          `เครื่องมือนี้สร้างขึ้นสำหรับผู้เรียน Google Career Certificate โดยมีชุดคำถามของแต่ละใบรับรอง และเปิดให้ทุกคนใช้ได้ พร้อมคำถามทั่วไปสำหรับหลายสาขา อ่าน [ประกาศของ Google เอง](${GOOGLE_BLOG_URL}) (ภาษาอังกฤษ)`,
          "การค้นหาหน้าวอร์มอัพของ Google อาจหมายถึงเรื่องอื่นได้เช่นกัน เช่น การวอร์มแคชของเว็บเซิร์ฟเวอร์หรือโดเมนอีเมล หน้านี้พูดถึงเครื่องมือฝึกสัมภาษณ์งาน",
        ],
      },
      {
        type: "text",
        badge: "วอร์มอัพที่รับฟังคุณ",
        title: "ฝึกพูดด้วยเสียงกับ AI ที่ตอบโต้กลับ",
        paragraphs: [
          "การพิมพ์คำตอบลงในช่องไม่ใช่การฝึกสัมภาษณ์ ที่ Just One Interview คุณพูด แล้วผู้สัมภาษณ์ AI จะฟังและตอบกลับด้วยเสียง ซึ่งสร้างแรงกดดันเบาๆ ให้คุณเหมือนการสัมภาษณ์รอบแรกจริง",
        ],
        points: ["สนทนาด้วยเสียงจริง ไม่ต้องพิมพ์", "คำถอดเสียงสดของบทสนทนาขณะที่คุณพูด"],
      },
      {
        type: "text",
        badge: "ทุกตำแหน่ง",
        title: "คำถามตรงกับชื่อตำแหน่งของคุณ",
        paragraphs: [
          "พิมพ์ตำแหน่งที่คุณจะสัมภาษณ์ เพิ่มทักษะที่อยากฝึก และวางรายละเอียดงานถ้าคุณมี Just One Interview จะสร้างคำถามจากสิ่งที่คุณใส่ ไม่ว่าจะเป็นนักบัญชีระดับจูเนียร์หรือ Staff Engineer",
        ],
      },
      {
        type: "text",
        badge: "รายงานพร้อมคะแนน",
        title: "คะแนนทุกคำตอบ ไม่ใช่แค่คำปลอบใจ",
        paragraphs: [
          "เมื่อรอบฝึกจบ คุณจะได้รายงานภายในไม่กี่นาที รายงานให้คะแนนทุกคำถาม ยกสิ่งที่คุณพูดมาแสดง บอกว่าอะไรได้ผลและอะไรควรแก้ และเสนอวิธีพูดที่ดีขึ้นสำหรับบางคำตอบ ฝึก อ่าน แก้หนึ่งเรื่อง แล้วลองใหม่",
        ],
      },
      {
        type: "text",
        badge: "คุณเป็นผู้เลือก",
        title: "จะเปิดหรือปิดกล้อง คุณตัดสินใจเอง",
        paragraphs: [
          "Just One Interview จะบันทึกวิดีโอรอบฝึกก็ต่อเมื่อกล้องเปิดอยู่เท่านั้น และต้องหลังจากที่คุณติ๊กช่องยินยอมให้บันทึกก่อนเริ่มรอบ หากปิดกล้อง ระบบจะไม่บันทึกวิดีโอ คุณแชร์วิดีโอที่บันทึกจากการฝึกไม่ได้ และรายงานของคุณจะนับคำติดปาก (เช่น เอ่อ อ่า) ไม่ว่าจะเปิดกล้องหรือไม่ เมื่อพร้อมแล้ว คุณบันทึก The One ดูย้อนหลัง และเลือกได้ว่าจะส่งให้ทีมสรรหาบุคลากรหรือไม่",
        ],
      },
      {
        type: "text",
        badge: "เริ่มฟรี",
        title: "วอร์มอัพได้ก่อนสัมภาษณ์จริงไม่กี่นาที",
        paragraphs: [
          "คุณเลือกได้ว่ารอบฝึกจะยาวแค่ไหน และใช้ได้ในเบราว์เซอร์บนแล็ปท็อปหรือโทรศัพท์ Just One Interview เริ่มใช้ได้ฟรี คุณจึงฝึกจนจบหนึ่งรอบเต็มและอ่านรายงานพร้อมคะแนนได้ก่อนสัมภาษณ์จริง",
        ],
      },
      {
        type: "table",
        id: "status",
        title: "แหล่งข้อมูลและสถานะของ Interview Warmup",
        paragraphs: ["นี่คือสิ่งที่เราตรวจสอบเมื่อวันที่ 22 ตุลาคม 2026 และสิ่งที่แต่ละแหล่งข้อมูลแสดงและไม่แสดง"],
        head: ["แหล่งข้อมูล", "สถานะเมื่อวันที่ 22 ตุลาคม 2026", "ลิงก์", "สิ่งที่แสดง"],
        rows: [
          [
            "หน้า Grow with Google เดิม",
            "เปิดเครื่องมือไม่ได้ ระบบพาเราไปที่หน้าแรกของ Grow with Google",
            "[grow.google/interview-warmup](https://grow.google/interview-warmup)",
            "จากที่ที่เราตรวจสอบ ที่อยู่เดิมไม่พาไปที่เครื่องมือฝึกอีกแล้ว ในประเทศอื่นอาจเป็นอีกแบบ",
          ],
          [
            "ประกาศของ Google ปี 2022",
            "ยังออนไลน์อยู่",
            `[blog.google, Helping job seekers prepare for interviews](${GOOGLE_BLOG_URL})`,
            "เครื่องมือนี้คืออะไรและทำงานอย่างไร เขียนไว้ในปี 2022 จึงไม่ได้พูดถึงการสิ้นสุดของเครื่องมือ",
          ],
          [
            "หน้าแรกของ Grow with Google",
            "เปิดอยู่",
            "[grow.google](https://grow.google/)",
            "Grow with Google ยังมีหลักสูตรและใบรับรองด้านอาชีพ หน้าที่เราเข้าถึงไม่ได้แสดง Interview Warmup",
          ],
          [
            "หน้าความช่วยเหลือของ Google",
            "เราไม่พบหน้าความช่วยเหลือเกี่ยวกับ Interview Warmup",
            "ไม่พบหน้า",
            "เราไม่พบประกาศจาก Google เรื่องเครื่องมือนี้สิ้นสุดลง",
          ],
        ],
      },
      {
        type: "table",
        id: "free-tools",
        title: "วิธีเตรียมสัมภาษณ์งานด้วย AI แบบฟรี",
        paragraphs: [
          "Just One Interview เริ่มใช้ได้ฟรีและไม่ขอบัตร ส่วนเครื่องมือประเภทอื่น ข้อจำกัดของแพ็กเกจฟรีเปลี่ยนไปได้ ดังนั้นควรอ่านหน้าของแต่ละเครื่องมือก่อนวางแผนใช้งาน ตารางนี้แสดงว่าแต่ละประเภทเหมาะกับอะไร",
        ],
        head: ["ตัวเลือก", "แพ็กเกจฟรี", "ฝึกด้วยเสียง", "คำถามตามตำแหน่ง", "ฟีดแบ็ก", "เหมาะกับ"],
        rows: [
          ["แชตบอท AI ทั่วไป", "ดูที่หน้าของเครื่องมือนั้น ข้อจำกัดเปลี่ยนได้", "แล้วแต่เครื่องมือ", "ตรงได้เท่ากับรายละเอียดงานที่คุณวางเข้าไปเท่านั้น", "คอมเมนต์เป็นข้อความจากแชต ไม่มีคะแนนตายตัวถ้าไม่ได้ขอ", "ไอเดียคำถามและร่างคำตอบแบบ STAR"],
          ["Just One Interview", "เริ่มใช้ฟรี ไม่ต้องใช้บัตร มีโควตาฝึกรายเดือน", "มี คุณพูด ผู้สัมภาษณ์ AI ตอบกลับด้วยเสียง และใช้ได้ในเบราว์เซอร์บนแล็ปท็อปหรือโทรศัพท์", "มี คุณพิมพ์ตำแหน่งและทักษะ และวางรายละเอียดงานได้", "รายงานพร้อมคะแนน: คะแนนรวม คะแนนแต่ละคำถาม จุดแข็ง สิ่งที่ควรพัฒนา คำตอบตัวอย่าง และจำนวนคำติดปาก", "การสัมภาษณ์จำลองด้วยเสียงแบบเต็มรูปแบบ พร้อมคำถามต่อเนื่อง"],
          ["Google Interview Warmup", "ใครก็ใช้ได้ในช่วงที่เปิดให้บริการ ตอนนี้เปิดจากที่อยู่เดิมไม่ได้แล้ว", "มี คุณพูดและระบบถอดเสียงคำตอบ", "ชุดคำถามของแต่ละ Google Career Certificate และคำถามทั่วไป", "ข้อมูลเชิงลึกเรื่องคำศัพท์เกี่ยวกับงาน คำที่ใช้บ่อย และประเด็นหลัก ไม่มีเกรด", "ซ้อมเร็วๆ ในตอนที่ยังเปิดให้ใช้"],
          ["เครื่องมือสวมบทบาทด้วยเสียง", "ดูที่หน้าของเครื่องมือนั้น ข้อจำกัดเปลี่ยนได้", "มี คุณพูดคุยตามสถานการณ์ที่กำหนด", "แล้วแต่เครื่องมือ", "แล้วแต่เครื่องมือ", "ฝึกบทสนทนา เช่น การคุยกับผู้สรรหาบุคลากรหรือการคุยกับลูกค้า"],
          ["เครื่องมือโค้ชการพูด", "ดูที่หน้าของเครื่องมือนั้น ข้อจำกัดเปลี่ยนได้", "มี", "ไม่ใช่จุดเน้น เครื่องมือเหล่านี้ดูที่วิธีการพูดของคุณ", "การนำเสนอ: จังหวะ คำติดปาก และความชัดเจน", "เมื่อคำตอบของคุณดีอยู่แล้วแต่การพูดทำให้เสียคะแนน"],
          ["เครื่องมือสัมภาษณ์จำลองสายเทคนิค", "ดูที่หน้าของเครื่องมือนั้น ข้อจำกัดเปลี่ยนได้", "แล้วแต่เครื่องมือ หลายตัวเป็นเซสชันเขียนโค้ดสดหรือใช้ไวต์บอร์ด", "มี สำหรับหัวข้อเทคนิค", "ขึ้นกับเครื่องมือ: การรันโค้ด เพื่อนร่วมฝึก หรือผู้เชี่ยวชาญ", "ฝึกเขียนโค้ดและออกแบบระบบ"],
        ],
      },
      {
        type: "table",
        id: "choose",
        title: "วิธีเลือกเครื่องมือฝึกสัมภาษณ์งานด้วย AI",
        paragraphs: [
          "เลือกเครื่องมือที่สร้างคำถามจากตำแหน่งของคุณเอง ถามคำถามต่อเนื่อง และให้ฟีดแบ็กที่ผูกกับสิ่งที่คุณพูดจริง ใช้เช็กลิสต์นี้กับเครื่องมือใดก็ได้ คอลัมน์สุดท้ายบอกว่า Just One Interview ทำอะไร",
        ],
        head: ["สิ่งที่ควรตรวจสอบ", "ทำไมจึงสำคัญ", "Just One Interview"],
        rows: [
          ["คำถามที่สร้างจากตำแหน่งหรือรายละเอียดงานของคุณ", "คำถามทั่วไปไม่ตรงกับการสัมภาษณ์ที่คุณจะเจอ", "คุณพิมพ์ตำแหน่งและทักษะ และวางรายละเอียดงานได้ คำถามจะตามสิ่งที่คุณใส่"],
          ["ประเภทของคำถามที่การสัมภาษณ์ของคุณจะใช้", "คำถามเชิงพฤติกรรม คำถามเทคนิค และคำถามเฉพาะตำแหน่งต้องฝึกต่างกัน", "บอกทักษะที่อยากให้ครอบคลุมตอนตั้งค่ารอบฝึก"],
          ["คำถามต่อเนื่อง", "ผู้สัมภาษณ์จริงจะถามเพิ่มเมื่อคำตอบยังบางอยู่", "เมื่อคำตอบสั้นหรือกว้างเกินไป ผู้สัมภาษณ์ AI จะถามต่อ"],
          ["ฟีดแบ็กที่ผูกกับสิ่งที่คุณพูด", "คำแนะนำที่ยกคำตอบของคุณมาแสดงนำไปทำตามได้ง่ายกว่า", "รายงานยกคำตอบของคุณมาแสดง และเก็บคำถอดเสียงไว้"],
          ["คะแนนของแต่ละคำตอบ", "ทำให้เห็นว่าควรแก้คำตอบไหนก่อน", "รายงานให้คะแนนรวมและคะแนนแต่ละคำถาม พร้อมจุดแข็ง สิ่งที่ควรพัฒนา และคำตอบตัวอย่าง"],
          ["บันทึกที่นำกลับมาใช้ได้", "คุณเปรียบเทียบแต่ละรอบและดูได้ว่าอะไรเปลี่ยนไป", "รายงานการฝึกที่ผ่านมาอยู่ในบัญชีของคุณ"],
          ["คำตอบด้วยเสียง ไม่ใช่การพิมพ์", "จังหวะการพูดและคำติดปาก จะปรากฏเมื่อคุณพูดเท่านั้น", "คุณพูด และระบบนับคำติดปาก ของคุณ"],
          ["ข้อจำกัดของแพ็กเกจฟรีที่ชัดเจน", "คุณวางแผนการฝึกตามสิ่งที่ใช้ได้ฟรีได้", "เริ่มฟรีโดยไม่ต้องใช้บัตร และมีโควตาฝึกรายเดือน"],
        ],
        after: [
          "ถ้าคุณเป็นฝ่ายสรรหาบุคลากรไม่ใช่ผู้ฝึก และกำลังหาเครื่องมือที่ให้คะแนนจากคำถอดเสียงและเขียนบันทึกสัมภาษณ์แบบมีโครงสร้าง เช็กลิสต์จะเปลี่ยนไป ให้มองหาคำถอดเสียงที่แม่นยำ การให้คะแนนจากแนวทางที่สร้างขึ้นสำหรับตำแหน่งนั้น หลักฐานเบื้องหลังทุกคะแนน บันทึกที่จัดกลุ่มตามคำถาม และความเข้ากันได้กับ ATS ของคุณ AI Interview Agents ให้คะแนนพร้อมเหตุผลเป็นลายลักษณ์อักษรที่ผูกกับสิ่งที่ผู้สมัครพูด พร้อมคำถอดเสียง และการเชื่อมต่อกับ ATS มีเพียงการนำเข้าจาก Greenhouse ทางเดียว ดู [ผู้สัมภาษณ์ AI สำหรับผู้สรรหาบุคลากร](/recruiters/ai-interviewer) (ภาษาอังกฤษ)",
        ],
      },
    ],
    faq: [
      {
        q: "Google Interview Warmup ยังใช้ได้อยู่ไหม",
        a: "ไม่ได้แล้ว Google ปิด Interview Warmup ในเดือนเมษายน 2026 และที่อยู่เดิมก็เปิดไม่ได้อีก สำหรับการฝึกพูดด้วยเสียง เราแนะนำให้ผู้สมัครใช้ Just One Interview แอปฝึกสัมภาษณ์ของเรา ซึ่งเริ่มใช้ได้ฟรี คุณคุยกับผู้สัมภาษณ์ AI และได้รายงานพร้อมคะแนนเมื่อจบ",
      },
      {
        q: "วอร์มอัพสัมภาษณ์นี้ฟรีไหม",
        a: "ฟรี Just One Interview เริ่มใช้ได้ฟรี และการสมัครไม่ต้องใช้บัตร",
      },
      {
        q: "ต่างจากการฝึกกับ ChatGPT หรือ Gemini อย่างไร",
        a: "ผู้ช่วยแชตตอบกลับเป็นข้อความ แต่ที่ Just One Interview คุณพูดกับผู้สัมภาษณ์ AI ที่ถามคำถามด้วยเสียงและฟังคำตอบของคุณ เมื่อจบ คุณได้รายงานพร้อมคะแนน ระบบจะบันทึกวิดีโอรอบฝึกก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมแล้วเท่านั้น และคุณปิดกล้องได้",
      },
      {
        q: "วอร์มอัพสำหรับตำแหน่งอะไรได้บ้าง",
        a: "ตำแหน่งใดก็ได้ที่คุณพิมพ์ได้ คุณเพิ่มทักษะที่อยากฝึกและวางรายละเอียดงานได้ Just One Interview ยังมีหน้าคำถามของแต่ละบริษัทให้คุณฝึกตามได้ด้วย",
      },
      {
        q: "Google Interview Warmup คืออะไร",
        a: "Google Interview Warmup เป็นเครื่องมือของ Grow with Google สำหรับฝึกตอบคำถามสัมภาษณ์ Google ประกาศเปิดตัวเมื่อวันที่ 2 มิถุนายน 2022 คุณตอบคำถามที่ผู้เชี่ยวชาญในแต่ละอุตสาหกรรมเลือกไว้ เครื่องมือถอดเสียงคำตอบของคุณ และแสดงข้อมูลเชิงลึก เช่น คำศัพท์เกี่ยวกับงานที่คุณใช้ คำที่คุณใช้บ่อยที่สุด และประเด็นหลักในแต่ละคำตอบ เครื่องมือไม่ให้เกรดคุณ สร้างขึ้นสำหรับผู้เรียน Google Career Certificate และเปิดให้ทุกคนใช้ได้",
      },
      {
        q: "ใช้เครื่องมือฟรีอะไรเตรียมสัมภาษณ์งานด้วย AI ได้บ้าง",
        a: "มีเครื่องมืออยู่ห้าประเภท ได้แก่ แชตบอท AI ทั่วไป แอปสัมภาษณ์จำลองด้วยเสียง เครื่องมือสวมบทบาทด้วยเสียง เครื่องมือโค้ชการพูด และแพลตฟอร์มสัมภาษณ์จำลองสายเทคนิค Just One Interview แอปสัมภาษณ์จำลองด้วยเสียงของเรา เริ่มใช้ได้ฟรีโดยไม่ต้องใช้บัตร ส่วนตัวอื่นๆ ข้อจำกัดของแพ็กเกจฟรีเปลี่ยนไปได้ ดังนั้นควรอ่านหน้าของแต่ละเครื่องมือก่อนพึ่งพา ตารางเปรียบเทียบในหน้านี้แสดงว่าแต่ละประเภทเหมาะกับอะไร",
      },
      {
        q: "เครื่องมือฝึกสัมภาษณ์ด้วย AI ควรมีฟีเจอร์อะไรบ้าง",
        a: "มองหาคำถามที่สร้างจากตำแหน่งหรือรายละเอียดงานของคุณ การฝึกคำถามเชิงพฤติกรรมและเทคนิค คำถามต่อเนื่อง ฟีดแบ็กที่ผูกกับสิ่งที่คุณพูด คะแนนของแต่ละคำตอบ และบันทึกที่นำกลับมาใช้ได้ Just One Interview สร้างคำถามจากตำแหน่งและทักษะที่คุณพิมพ์ รวมถึงรายละเอียดงานที่คุณวาง ถามคำถามต่อเนื่อง และให้รายงานพร้อมคะแนน ซึ่งมีคะแนนแต่ละคำถาม จุดแข็ง สิ่งที่ควรพัฒนา คำตอบตัวอย่าง และคำที่คุณพูดเอื่อยๆ การฝึกเป็นภาษาอังกฤษ เช็กลิสต์ฉบับเต็มอยู่ในหน้านี้",
      },
      {
        q: "ฉันหาลิงก์ไม่เจอ คุณต้องการลิงก์ไหน",
        a: "ถ้าคุณกำลังหา Google Interview Warmup ที่อยู่เดิมคือ grow.google/interview-warmup ไม่เปิดเครื่องมืออีกแล้ว ถ้าต้องการฝึก ปุ่มเริ่มฟรีในหน้านี้จะเปิด Just One Interview ซึ่งเริ่มใช้ได้ฟรี ถ้าคุณหมายถึงคำเชิญสัมภาษณ์ ให้ตรวจอีเมลของคุณ รวมถึงโฟลเดอร์สแปม และขอให้นายจ้างส่งใหม่ ถ้ายังเปิดไม่ได้ เขียนมาที่ contact@aiinterviewagents.com พร้อมลิงก์ที่คุณลอง ข้อความแจ้งข้อผิดพลาดที่แน่นอน และอุปกรณ์ที่คุณใช้",
      },
    ],
    closing: {
      title: "ฝึกที่ Just One Interview",
      text: "เริ่มใช้ได้ฟรีและไม่ขอบัตร พิมพ์ตำแหน่ง เพิ่มทักษะของคุณ แล้วเริ่มพูดได้เลย",
      button: "เริ่มฟรี",
    },
  },

  "ai-video-interview": {
    title: "ฝึกสัมภาษณ์งานกับ AI ผ่านวิดีโอ ฟรี เปิดกล้องได้",
    description:
      "ฝึกสัมภาษณ์วิดีโอกับ AI ฟรีที่ Just One Interview คุยกับผู้สัมภาษณ์ AI เปิดกล้อง แล้วรับรายงานพร้อมคะแนน การเปิดกล้องเป็นสิทธิ์ของคุณ ระบบบันทึกก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอม",
    h1: "ฝึกสัมภาษณ์วิดีโอกับ AI: บทสนทนาจริง เปิดกล้อง",
    lead:
      "ในการสัมภาษณ์วิดีโอกับ AI คุณคุยกับผู้สัมภาษณ์ AI และในการสัมภาษณ์รับสมัครงานจริง มักมีการบันทึกไว้ หากต้องการฝึก ใช้ Just One Interview แอปฝึกสัมภาษณ์ของเรา AI ถามคำถามที่สร้างจากตำแหน่งที่คุณเลือก และเมื่อจบคุณจะได้รายงานแบบละเอียด ระบบจะบันทึกวิดีโอรอบฝึกก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมแล้วเท่านั้น",
    cta: "เริ่มฝึกฟรี →",
    blocks: [
      {
        type: "text",
        title: "การสัมภาษณ์วิดีโอที่ขับเคลื่อนด้วย AI คืออะไร",
        paragraphs: [
          "การสัมภาษณ์วิดีโอที่ขับเคลื่อนด้วย AI คือการสัมภาษณ์งานผ่านวิดีโอที่ AI เป็นผู้ดำเนินการหรือประเมินกระบวนการ มักใช้คำตอบที่บันทึกไว้สำหรับคำถามที่กำหนดไว้ล่วงหน้า ซอฟต์แวร์อาจถอดเสียงคำตอบ สรุปคำตอบ ให้คะแนนหรือจัดอันดับผู้สมัคร หรือประเมินว่าสื่อสารได้ดีแค่ไหน แล้วผู้สรรหาบุคลากรจะตรวจดูผลเพื่อตัดสินว่าใครได้ไปต่อ",
          "นายจ้างใช้วิธีนี้เพื่อคัดกรองผู้สมัครจำนวนมากอย่างสม่ำเสมอขึ้น บางแบบเป็นการบันทึกทางเดียว และบางแบบเป็นบทสนทนาสดกับผู้สัมภาษณ์ AI และแบบที่คุณเจอก็เปลี่ยนสิ่งที่ถามและสิ่งที่ให้คะแนน",
        ],
      },
      {
        type: "text",
        title: "การสัมภาษณ์วิดีโอกับ AI ส่วนใหญ่เป็นการบันทึกทางเดียว",
        paragraphs: [
          "ปัญหาของเครื่องมือสัมภาษณ์วิดีโอกับ AI ส่วนใหญ่คือ มันแค่บันทึกภาพคุณพูดอยู่คนเดียว คุณอ่านคำถามจากหน้าจอ บันทึกวิดีโอคำตอบทางเดียว แล้วโมเดลให้คะแนนคลิปนั้น นี่ไม่ใช่วิธีที่การสัมภาษณ์จริงทำงาน การสัมภาษณ์จริงคือการสนทนา ผู้สัมภาษณ์ตอบสนองต่อสิ่งที่คุณพูด ซักจุดอ่อน เจาะลึกคำตอบที่แข็งแรง และสร้างแรงกดดันแบบที่ทำให้เห็นว่าคุณทำได้จริงแค่ไหน",
          "AI Interview Agents จัดการสัมภาษณ์วิดีโอสองทางแทน ผู้สัมภาษณ์ AI ที่ฟังและพูดตอบด้วยเสียงโดยตรงคุยกับคุณแบบเรียลไทม์ เข้าใจเนื้อหาของคำตอบแทนการจับคู่คำสำคัญ และถามคำถามถัดไปจากสิ่งที่คุณพูด สำหรับการฝึก Just One Interview ให้คุณคุยด้วยเสียงโดยเปิดกล้อง ระบบจะบันทึกวิดีโอรอบนั้นก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมแล้วเท่านั้น และฟีดแบ็กของคุณมาในรายงานพร้อมคะแนน",
        ],
      },
      {
        type: "table",
        title: "เครื่องมือสัมภาษณ์วิดีโอกับ AI แบบเรียบง่าย",
        paragraphs: [
          "Spark Hire เป็นจุดเริ่มต้นที่เรียบง่ายสำหรับการสัมภาษณ์วิดีโอทางเดียวที่ผู้สมัครตอบเมื่อไหร่ก็ได้ โดยเปิดเผยราคาและขายแบบรายเดือน ในการสัมภาษณ์ทางเดียว ผู้สมัครแต่ละคนจะได้ลิงก์และคำถามที่กำหนดไว้ แล้วบันทึกคำตอบเมื่อสะดวก จึงไม่ต้องนัดเวลาโทร",
          "กำลังฝึกสัมภาษณ์อยู่ใช่ไหม ข้ามไปที่ จากตำแหน่งสู่รายงานในครั้งเดียว ตารางนี้สำหรับคนที่กำลังเลือกเครื่องมือเพื่อใช้รับสมัครงาน",
        ],
        head: ["เครื่องมือ", "ประเภท", "ราคาที่เปิดเผย ตรวจสอบเมื่อวันที่ 22 ตุลาคม 2026", "แหล่งข้อมูล"],
        rows: [
          ["Spark Hire", "สัมภาษณ์วิดีโอทางเดียวและแบบสด", "เริ่มที่ $249 ต่อเดือนเมื่อเรียกเก็บรายปี หรือเริ่มที่ $299 ต่อเดือนเมื่อเรียกเก็บรายเดือน ราคาแตกต่างตามขนาดบริษัท", "[sparkhire.com/pricing](https://www.sparkhire.com/pricing/)"],
          ["Hireflix", "สัมภาษณ์วิดีโอทางเดียว", "$150 ต่อเดือน หรือ $75 ต่อเดือนเมื่อเรียกเก็บรายปี สำหรับบริษัทที่มีพนักงานไม่ถึง 50 คน เดือนแรกใช้ฟรี", "[hireflix.com/pricing](https://hireflix.com/pricing)"],
          ["Interviewer.AI", "สัมภาษณ์วิดีโอที่บันทึกไว้พร้อมรายงานการประเมิน และสัมภาษณ์ AI แบบสนทนา", "เริ่มที่ $199 ต่อเดือน มีทดลองใช้ฟรี 14 วัน", "[interviewer.ai/pricing](https://interviewer.ai/pricing/)"],
          ["HireVue", "การสัมภาษณ์และการคัดกรองด้วย AI", "ไม่เปิดเผยราคา หน้าราคาเป็นแบบฟอร์มติดต่อ", "[hirevue.com/pricing](https://www.hirevue.com/pricing)"],
        ],
        after: [
          "OneWayInterview.com และ TestGorilla ก็ปรากฏในการค้นหานี้เช่นกัน เรายังไม่ได้ตรวจสอบแพ็กเกจของทั้งสอง จึงควรดูที่เว็บไซต์ของเขาเอง ราคาเปลี่ยนได้ ดังนั้นควรยืนยันที่หน้าของแต่ละผู้ให้บริการก่อนซื้อ",
          "เครื่องมือทางเดียวถามคำถามต่อเนื่องไม่ได้ ถ้าต้องการผู้สัมภาษณ์ AI ที่ฟังและถามต่อ ดู [ซอฟต์แวร์สัมภาษณ์วิดีโอด้วย AI สำหรับผู้สรรหาบุคลากร](/recruiters/ai-video-interview-software) หรือ [การเปรียบเทียบผู้ให้บริการ](/compare) (ภาษาอังกฤษ)",
        ],
      },
      {
        type: "steps",
        title: "จากตำแหน่งสู่รายงานในครั้งเดียว",
        steps: [
          {
            title: "ขั้นที่ 1: เลือกตำแหน่ง",
            text: "พิมพ์ตำแหน่งที่คุณกำลังเตรียมตัว เช่น Senior Product Manager หรือ Junior Mechanical Engineer และเพิ่มทักษะที่อยากฝึก คุณวางรายละเอียดงานได้ด้วย Just One Interview จะสร้างคำถามจากสิ่งที่คุณใส่",
          },
          {
            title: "ขั้นที่ 2: คุยกัน",
            text: "คุยกันด้วยเสียง ผู้สัมภาษณ์ AI ถามคำถามด้วยเสียงและฟังคำตอบของคุณ และคุณกดปุ่มเมื่อตอบแต่ละข้อจบ คุณเลือกได้ว่ารอบฝึกจะยาวแค่ไหน ระบบจะบันทึกวิดีโอก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมก่อนเท่านั้น",
          },
          {
            title: "ขั้นที่ 3: รับรายงาน",
            text: "รับรายงานไม่กี่นาทีหลังจบ รายงานแสดงคะแนนของคุณ สิ่งที่ได้ผล สิ่งที่ควรแก้ และวิธีพูดที่ดีขึ้นสำหรับบางคำตอบ รายงานการฝึกที่ผ่านมาอยู่ในบัญชีของคุณ คุณจึงเปรียบเทียบได้",
          },
        ],
      },
      {
        type: "chips",
        title: "ฝึกได้ทุกตำแหน่ง ไม่ใช่แค่สายเทคโนโลยี",
        paragraphs: [
          "วิศวกรซอฟต์แวร์ แน่นอน แต่ยังรวมถึงเชฟขนมหวาน นักชีววิทยาทางทะเล หัวหน้าฝ่ายขาย นักวิเคราะห์วาณิชธนกิจ นักออกแบบ UX ผู้จัดการซัพพลายเชน นักจิตวิทยาคลินิก ที่ Just One Interview คุณพิมพ์ชื่อตำแหน่งเอง จึงไม่มีตำแหน่งไหนที่อยู่เกินเอื้อม",
        ],
        items: ["วิศวกรซอฟต์แวร์", "นักวิเคราะห์ข้อมูล", "การตลาด", "ผู้จัดการผลิตภัณฑ์", "นักออกแบบ UX", "นักจิตวิทยา", "ช่างตัดผม"],
      },
      {
        type: "text",
        title: "การสัมภาษณ์วิดีโอกับ AI แบบสองทางต่างออกไปอย่างไร",
        paragraphs: [],
      },
      {
        type: "box",
        title: "การสัมภาษณ์วิดีโอกับ AI ทำงานอย่างไร",
        text: "นายจ้างส่งลิงก์ให้ผู้สมัคร ผู้สมัครตอบด้วยวิดีโอ แล้วซอฟต์แวร์แปลงคำตอบเป็นคำถอดเสียงและสรุปพร้อมคะแนนให้ผู้สรรหาบุคลากรตรวจดู มีสองแบบที่พบบ่อย ในการสัมภาษณ์ทางเดียวแบบไม่พร้อมกัน ผู้สมัครบันทึกคำตอบสำหรับคำถามที่กำหนดไว้ตอนไหนก็ได้ ในการสัมภาษณ์สดที่มี AI ช่วย ผู้สัมภาษณ์ AI ถามคำถามแบบเรียลไทม์และถามต่อได้ ขึ้นอยู่กับเครื่องมือ ซอฟต์แวร์จะถอดเสียงคำตอบ วิเคราะห์ และสร้างคะแนน สรุป แท็ก หรือรายชื่อผู้ที่ผ่านเข้ารอบ ผู้สรรหาบุคลากรที่เป็นคนมักตรวจดูผลและตัดสินว่าใครได้ไปรอบถัดไป",
      },
      {
        type: "table",
        head: ["รูปแบบ", "สองทาง", "ฟีดแบ็ก", "บันทึก", "ทุกตำแหน่ง"],
        rows: [
          ["การฝึกบน Just One Interview", "ใช่", "รายงานพร้อมคะแนน", "เฉพาะเมื่อเปิดกล้องและคุณยินยอม", "ตำแหน่งใดก็ได้ที่คุณพิมพ์"],
          ["บันทึกวิดีโอทางเดียว", "ไม่", "คะแนนพื้นฐาน", "เป็นวิดีโอ", "จำกัด"],
          ["ฝึกด้วยข้อความหรือแชต", "ไม่", "พื้นฐาน", "ไม่", "จำกัด"],
          ["ฝึกหน้ากระจก", "ไม่", "ไม่มี", "ไม่", "ตำแหน่งใดก็ได้"],
          ["สัมภาษณ์จำลองสดกับคนจริง", "ใช่", "จากผู้เชี่ยวชาญ", "นานๆ ครั้ง", "แล้วแต่กรณี"],
        ],
      },
      {
        type: "text",
        title: "สร้างมาสำหรับนักศึกษา ผู้เปลี่ยนสายอาชีพ และทุกคนที่เตรียมตัวสัมภาษณ์",
        paragraphs: [
          "นักศึกษาที่เตรียมตัวสมัครงานผ่านการรับสมัครในมหาวิทยาลัย ผู้เปลี่ยนสายอาชีพที่ฝึกสำหรับอุตสาหกรรมที่ไม่คุ้นเคย ผู้มีประสบการณ์ที่วอร์มอัพสำหรับรอบระดับอาวุโส และทุกคนที่ประหม่าเวลาอยู่หน้ากล้อง การฝึกอย่างมีโครงสร้างพร้อมรายงานไม่กี่นาทีหลังจบเหมาะกับทุกคนเหล่านี้ เนื่องจากบริษัทจำนวนมากขึ้นใช้การสัมภาษณ์วิดีโอกับ AI ของตัวเองในการรับสมัคร การฝึกรูปแบบนี้ก่อนที่มันจะมีผลจริงจึงเป็นความได้เปรียบที่ง่ายที่สุดที่คุณมอบให้ตัวเองได้",
          "มีเวลาแค่ไม่กี่นาทีใช่ไหม ลอง[วอร์มอัพสัมภาษณ์](/th/features/interview-warmup)แบบเร็วแทน ทีมสรรหาบุคลากรที่อยากใช้การสัมภาษณ์วิดีโอกับ AI ดู[ซอฟต์แวร์สัมภาษณ์วิดีโอด้วย AI สำหรับผู้สรรหาบุคลากร](/recruiters/ai-video-interview-software) (ภาษาอังกฤษ)",
        ],
      },
    ],
    faq: [
      {
        q: "การสัมภาษณ์วิดีโอกับ AI คืออะไร",
        a: "การสัมภาษณ์งานที่ผู้สัมภาษณ์ AI ทำผ่านวิดีโอ ในการสัมภาษณ์วิดีโอกับ AI แบบสองทาง คุณพูดกับ AI แบบเรียลไทม์ AI ถามคำถาม ฟัง และถามต่อ การสัมภาษณ์ของนายจ้างมีการบันทึกเพื่อให้ให้คะแนนและดูย้อนหลังได้ รอบฝึกบน Just One Interview จะบันทึกวิดีโอก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมแล้วเท่านั้น",
      },
      {
        q: "ฝึกสัมภาษณ์วิดีโอกับ AI ได้อย่างไร",
        a: "บน Just One Interview พิมพ์ชื่อตำแหน่ง เพิ่มทักษะของคุณ และวางรายละเอียดงานถ้าคุณมี คุณเลือกได้ว่ารอบฝึกจะยาวแค่ไหนและตอบด้วยเสียง เมื่อจบคุณได้รายงานพร้อมคะแนน ระบบจะบันทึกวิดีโอก็ต่อเมื่อกล้องเปิดอยู่และคุณยินยอมก่อนเท่านั้น และเริ่มใช้ได้ฟรี",
      },
      {
        q: "การสัมภาษณ์วิดีโอกับ AI บันทึกภาพคุณไหม",
        a: "การสัมภาษณ์รับสมัครงานจริงมักบันทึก และผู้สรรหาบุคลากรจะดูการบันทึกนั้น การฝึกบน Just One Interview จะบันทึกวิดีโอก็ต่อเมื่อกล้องเปิดอยู่เท่านั้น และต้องหลังจากที่คุณติ๊กช่องยินยอมให้บันทึก หากปิดกล้อง ระบบจะไม่บันทึกวิดีโอ คุณแชร์วิดีโอที่บันทึกจากการฝึกไม่ได้ เมื่อพร้อมแล้ว คุณบันทึก The One ดูย้อนหลัง และเลือกได้ว่าจะส่งหรือไม่",
      },
      {
        q: "ทำอย่างไรให้สัมภาษณ์วิดีโอกับ AI ได้ผลดี",
        a: "ตอบด้วยเสียงเป็นประโยคเต็ม เรียบเรียงคำตอบด้วยสถานการณ์ การกระทำ และผลลัพธ์ และยกตัวอย่างเจาะจงแทนการพูดกว้างๆ AI ให้คะแนนจากเนื้อหา ไม่ใช่คำสำคัญ การฝึกสองสามครั้งช่วยลดความกังวลเรื่องรูปแบบไปได้เกือบทั้งหมด",
      },
      {
        q: "AI วิเคราะห์การสัมภาษณ์วิดีโอได้ไหม",
        a: "ได้ ขึ้นอยู่กับเครื่องมือ AI ถอดเสียงสิ่งที่ผู้สมัครพูดและประเมินเนื้อหา ความชัดเจน โครงสร้าง และจังหวะของคำตอบได้ บางเครื่องมือยังดูลักษณะของเสียงหรือสัญญาณทางภาพ และบางเครื่องมือให้คะแนนคำตอบตามเกณฑ์ของงาน การวิเคราะห์เสียงและวิดีโอเป็นส่วนที่ถกเถียงกันมากที่สุด เพราะอาจมีอคติ ความน่าเชื่อถือต่างกันไป และความเป็นธรรมเป็นข้อกังวลจริง จึงควรให้คนตรวจดูผล AI Interview Agents ให้คะแนนจากคำถอดเสียงของสิ่งที่ผู้สมัครพูด และไม่วิเคราะห์ใบหน้าหรือสีหน้า",
      },
      {
        q: "การสัมภาษณ์วิดีโอกับ AI ทำงานอย่างไร",
        a: "นายจ้างส่งลิงก์ให้ผู้สมัคร ในการสัมภาษณ์ทางเดียว ผู้สมัครบันทึกคำตอบสำหรับคำถามที่กำหนดไว้ตอนไหนก็ได้ ในการสัมภาษณ์สด ผู้สัมภาษณ์ AI ถามคำถามแบบเรียลไทม์และถามต่อได้ ซอฟต์แวร์สร้างคำถอดเสียง และอาจวิเคราะห์ สรุป ให้คะแนน หรือแท็กคำตอบเป็นรายชื่อผู้ที่ผ่านเข้ารอบ แล้วผู้สรรหาบุคลากรมักตรวจดูผลและตัดสินว่าใครได้ไปต่อ",
      },
      {
        q: "การสัมภาษณ์วิดีโอที่ขับเคลื่อนด้วย AI คืออะไร",
        a: "การสัมภาษณ์งานผ่านวิดีโอที่ AI เป็นผู้ดำเนินการหรือประเมินกระบวนการ มักใช้คำตอบที่บันทึกไว้สำหรับคำถามที่กำหนดไว้ล่วงหน้า ซอฟต์แวร์อาจถอดเสียง สรุป ให้คะแนน จัดอันดับ หรือประเมินคุณภาพการสื่อสาร และผู้สรรหาบุคลากรจะตรวจดูผล",
      },
      {
        q: "การสัมภาษณ์วิดีโอกับ AI ฟรีไหม",
        a: "การฝึกเริ่มใช้ได้ฟรี Just One Interview ไม่ขอบัตร ใช้ได้ในเบราว์เซอร์บนแล็ปท็อปหรือโทรศัพท์ และมีโควตาฝึกรายเดือน การสัมภาษณ์วิดีโอรับสมัครงานจริงนายจ้างเป็นผู้จัดให้ และผู้สมัครที่ได้รับเชิญไม่ต้องมีบัญชี ไม่ต้องมีไลเซนส์ และไม่ต้องติดตั้งอะไร หากคุณเป็นฝ่ายรับสมัครงาน AI Interview Agents มีแพ็กเกจฟรี และหน้าราคาแสดงว่าแต่ละแพ็กเกจมีอะไรบ้าง",
      },
      {
        q: "ใครจะเป็นคนสัมภาษณ์",
        a: "ในหน้านี้คือผู้สัมภาษณ์ AI ในรอบฝึกของ Just One Interview AI ถามคำถามด้วยเสียงและฟังคำตอบของคุณ ในการสัมภาษณ์จริงของนายจ้างขึ้นอยู่กับเครื่องมือ บางตัวแสดงคำถามที่กำหนดไว้ให้คุณบันทึกคำตอบ และบางตัวใช้ผู้สัมภาษณ์ AI แบบสด ผู้สรรหาบุคลากรหรือผู้จัดการฝ่ายรับสมัครมักตรวจดูผลภายหลังและเป็นผู้ตัดสิน ที่ AI Interview Agents ผู้สัมภาษณ์เป็น AI และคนในทีมรับสมัครเป็นผู้ตัดสิน",
      },
      {
        q: "เครื่องมือสัมภาษณ์วิดีโอกับ AI ตัวไหนใช้งานง่าย",
        a: "เครื่องมือที่ใช้งานง่ายคือเครื่องมือที่เปิดเผยราคา ขายแบบรายเดือน และใช้คำตอบที่บันทึกทางเดียว จึงไม่ต้องนัดเวลาโทร Spark Hire เข้าข่ายนี้ หน้าราคาของเขา ซึ่งตรวจสอบเมื่อวันที่ 22 ตุลาคม 2026 ระบุแพ็กเกจเริ่มที่ $249 ต่อเดือนเมื่อเรียกเก็บรายปี หรือเริ่มที่ $299 ต่อเดือนเมื่อเรียกเก็บรายเดือน และระบุว่าราคาแตกต่างตามขนาดบริษัท Hireflix, Interviewer.AI และ HireVue เป็นทางเลือก และ OneWayInterview.com กับ TestGorilla ก็ปรากฏเช่นกัน แต่เรายังไม่ได้ตรวจสอบแพ็กเกจของทั้งสอง หากต้องการให้ผู้สมัครถูกถามคำถามต่อเนื่อง ให้ใช้ผู้สัมภาษณ์ AI แบบสองทางอย่าง AI Interview Agents",
      },
    ],
    closing: {
      title: "เริ่มรอบฝึกแรกของคุณ",
      text: "เลือกตำแหน่งใดก็ได้ แล้วคุยกับผู้สัมภาษณ์ AI โดยเปิดกล้อง รับรายงานพร้อมคะแนนเมื่อจบ เริ่มใช้ได้ฟรี และคุณเป็นผู้เลือกว่าจะเปิดกล้องหรือไม่",
      button: "เริ่มฝึก",
    },
  },
};
